"use client";

import React from "react";

import { data } from "../../../constants/loginMetaData";

interface JsonLdProps {
  countryCode: "IN" | "SA" | "HK" | "ID" | "MY" | "PH" | "SG" | "TH" | "VN";
  isMonsterDomain: boolean;
}

export default function JsonLd({ countryCode, isMonsterDomain }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(
          data[isMonsterDomain ? "monster" : "foundit"][countryCode].JSONLD,
        ),
      }}
    />
  );
}
